<template>
  <div>
    <div class="myTop">
      <el-breadcrumb style="line-height: 60px;margin-left: 30px;" separator="/">
        <el-breadcrumb-item :to="{ path: '/equipmentManager/equipmentTypeManager' }">设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>设备台账</el-breadcrumb-item>
        <el-button
          type="primary"
          class="myBtn"
          @click="dialogFormVisible=true;ifadd=true;form={};newForm2={};word='新建'">新建</el-button>
      </el-breadcrumb>
    </div>

    <div style="position:relative;left: 10px;top: 10px">
      <div
        style="width:250px;display:flex;height:40px;background:#fff;justify-content: space-between;line-height:40px;align-items: center;">
        <span style="padding: 0 20px;font-size:22px">分类</span>
      </div>
      <el-collapse v-model="activeName" @change="changeClassId()" accordion>
        <el-collapse-item
          :title="item.className"
          :key="index"
          v-for="(item,index) in getInfo"
          :name="index">
          <div style="position:absolute">
            <i class="el-icon-delete delIcon" @click="handleDelClass(item.id)"></i>
            <i class="el-icon-more moreIcon" @click="handleChangeClass(item.id,index)"></i>
          </div>
        </el-collapse-item>
      </el-collapse>

      <div style="width: 83%;position:absolute;top:0;left:260px;">
        <el-table :data="tableData" stripe>
          <el-table-column label="设备位号" prop="deviceTag"></el-table-column>
          <el-table-column label="设备名称" prop="deviceName"></el-table-column>
          <el-table-column
            :label="item.name"
            :prop="item.prop"
            v-for="(item,index) in table"
            :key="index"></el-table-column>
          <el-table-column label="校验报告编号" prop="testReportNo"></el-table-column>
          <el-table-column label="下次校验日期" prop="nextTestTime">
            <template slot-scope="{ row }">
              <span v-if="row.nextTestTime">{{ row.nextTestTime | timeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="oper" label="操作">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <div slot="reference" class="name-wrapper">
                  <el-link
                    type="primary"
                    @click="handleChangeInfo(scope.row.id,scope.row);dialogFormVisible=true">编辑</el-link>｜
                  <el-link type="primary" @click="handleDelInfo(scope.row.id)">删除</el-link>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="block" style="position: relative;">
          <el-pagination
            style="position: absolute; right: 0; top: 0;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
      <el-dialog :title="word" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="设备位号">
            <el-input v-model="form.deviceTag"></el-input>
          </el-form-item>
          <el-form-item label="设备名称">
            <el-input v-model="form.deviceName"></el-input>
          </el-form-item>
          <el-form-item label="下次校验时间">
            <el-date-picker
              v-model="form.nextTestTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择下次校验时间"></el-date-picker>
          </el-form-item>
          <el-form-item :ref="key" :label="val" v-for="(val,key,index) in newForm" :key="index">
            <el-input v-model="newForm2[key]"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false;submitForm('form')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: "0",
      word: "新建",
      table: [],
      newcont: [],
      dialogVisible: false,
      activeName: "0",
      dialogFormVisible: false,
      currentId: "",
      showablData: "",
      form: {},
      newForm: {},
      newForm2: {
        context1: "",
        context2: "",
        context3: "",
        context4: "",
        context5: "",
        context6: "",
        context8: "",
      },
      getInfo: [],
      ifadd: true,
      classId: "",
      formLabelWidth: "120px",
      tableData: [],
      sizePage: 10,
      currentPage: 1,
      total: 10,
      nextTestTime: ""
    };
  },
  methods: {
    handleSizeChange(val) {
      this.sizePage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      //   this.deptGetInfo(this.currentPage, this.sizePage);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ifadd) {
            let formdata = new FormData();
            for (let key in this.form) {
              formdata.append(key, this.form[key]);
            }
            for (let key in this.newForm) {
              if (this.newForm2[key] !== "") {
                formdata.append(key, this.newForm2[key]);
              }
            }
            formdata.append("classId", this.classId);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").addDevLeder
              )
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                this.deptGetInfo(1, 10, this.classId);
              });
          } else if (!this.ifadd) {
            // console.log(this.currentId);
            let formdata = new FormData();
            for (let key in this.form) {
              formdata.append(key, this.form[key]);
            }
            for (let key in this.newForm) {
              if (this.newForm2[key] !== "") {
                formdata.append(key, this.newForm2[key]);
              }
            }
            formdata.append("classId", this.classId);
            formdata.append("id", this.currentId);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changeDevLeder
              )
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                this.deptGetInfo(1, 10, this.classId);
              });
          }
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    //添加信息
    handleAddInfo() {
      this.ifadd = true;
      this.form = {
        name: "",
        dataType: "",
        width: "",
        required: null,
      };
      this.dialogFormVisible = true;
    },
    //获取设备分类信息
    getdeviceClass() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getdeviceClass)
        .openLoad()
        .startGet()
        .then((res) => {
          this.getInfo = res.body.data;
          this.classId = this.getInfo[0].id;
          this.deptGetInfo(1, 10, this.classId);
        });
    },
    //获取设备台账信息
    deptGetInfo(page, limit, classId) {
      let formdata = new FormData();
      formdata.append("curPage", page);
      formdata.append("limit", limit);
      formdata.append("classId", classId);
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getDevLeder)
        .openLoad()
        .startPost(formdata)
        .then((res) => {
          this.newcont = res.body.data;
          this.tableData = [];
          for (let j = 0; j < res.body.data.length; j++) {
            var data = {};
            for (let i in res.body.data[j]) {
              data[i] = res.body.data[j][i].value;
            }
           // this.getInfo.forEach((item, index) => {});
            this.tableData.push(data);
          }

          this.table = [];
          this.getInfo.forEach((item) => {
            if (item.id == classId) {
              item.deviceClassDetailVos.forEach((its, indexs) => {
                this.table.push({
                  name: its.name,
                  prop: its.colName,
                });
                this.newForm[its.colName] = its.name;
              });
            }
          });
        });
    },
    //删除详细信息
    handleDelInfo(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").delDevLeder + id
        )
        .openLoad()
        .startDel()
        .then((res) => {
          if (res.result == "success") {
            this.deptGetInfo(1, 10, this.classId);
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        });
    },
    //改变具体信息
    handleChangeInfo(id, row) {
      this.word = "编辑";
      this.ifadd = false;
      this.currentId = id;
      this.form = {
        deviceTag: row.deviceTag,
        deviceName: row.deviceName,
      };

      for (let val in row) {
        this.newForm2[val] = row[val];
      }
    },
    //改变类名
    handleChangeClass(id, index) {
      this.ifcalssadd = false;
      this.dialogVisible = true;
      this.myform.name = this.getInfo[index].className;
    },
    handleDelClass(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").delClass + id)
        .openLoad()
        .startDel()
        .then((res) => {
          if (res.result == "success") {
            this.getdeviceClass();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        });
    },
    changeClassId() {
      this.classId = this.getInfo[this.activeName].id;
      //this.getdeviceClass();
      this.index = this.activeName;
      this.deptGetInfo(1, 10, this.classId);
    },
  },
  created() {
    this.getdeviceClass();
  },
};
</script>

<style>
.myTop {
  background-color: #ffffff;
  width: 90%;
  height: 60px;
  position: absolute;
  top: 0;
  left: 200px;
}
.myBtn {
  position: absolute;
  top: 10px;
  right: 30px;
}
.el-collapse {
  width: 250px;
  height: 850px;
  padding-left: 20px;
  background-color: #fff;
}
.delIcon {
  position: absolute;

  bottom: -10px;
  left: 200px;
}
.moreIcon {
  position: absolute;
  bottom: -10px;
  left: 160px;
}
.setAdd {
  width: 86%;
  height: 28px !important;
  display: block;
  border: 1px dashed #e9eef3;
  margin: 0 auto;
  line-height: 8px !important;
}
</style>
